import React from "react";

import { Toaster } from "sonner";

import DebugProvider from "./debug-provider";
import { LanguageInitializer } from "./language-initializer";
import { MessageBoxProvider } from "./messagebox-provider";
import TanStackQueryProvider from "./tanstack-query-provider";
import { ThemeProvider } from "./theme-provider";

/**
 * Providers Component
 *
 * This component serves as a wrapper for the application's providers.
 * It encapsulates the TanStackQueryProvider and DebugProvider, ensuring
 * that all child components have access to the necessary context and
 * debugging tools.
 *
 * @param props - The component props
 * @param props.children - The child components to be wrapped
 * @returns A React element wrapping the children with necessary providers
 */
function ProviderWrapper({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <ThemeProvider defaultTheme="light">
      <TanStackQueryProvider>
        <MessageBoxProvider>
          <LanguageInitializer />
          {children}
        </MessageBoxProvider>
        <Toaster duration={2000} position="top-right" />
        <DebugProvider />
      </TanStackQueryProvider>
    </ThemeProvider>
  );
}

export default ProviderWrapper;
